import { HttpErrorResponse } from '@angular/common/http';

export class Failure {
  constructor(
    public message: string,
    public code: string,
    public statusCode?: number,
  ) {}

  static fromHttpError(response: HttpErrorResponse): Failure {
    if (response.status === 0) {
      return new ConnectionFailure();
    }

    if (response.error) {
      if (response.error.message) {
        const message = response.error.message;
        return new ResponseFailure({
          response: response,
          message: Array.isArray(message) ? message.join('\n') : message,
          code: response.error.error,
          statusCode: response.status,
        });
      }
    }

    return new ResponseFailure({
      response: response,
      message: response.message,
      code: response.statusText,
      statusCode: response.status,
    });
  }

  static fromCognitoError(error: unknown): Failure {
    try {
      const { code, message } = error as { code?: string; message?: string };
      return new CognitoFailure({
        message: message ?? 'Unknown error',
        code: code ?? 'UNKNOWN_ERROR',
      });
    } catch (e) {
      return new UnknownFailure();
    }
  }
}

export class CognitoFailure extends Failure {
  constructor(
    public init: {
      message: string;
      code: string;
    },
  ) {
    super(init.message, init.code);
  }
}

export class ConnectionFailure extends Failure {
  constructor() {
    super('Could not connect to server, please check your internet connection.', 'CONNECTION_FAILURE');
  }
}

export class ResponseFailure extends Failure {
  constructor(
    public init: {
      response: HttpErrorResponse;
      message: string;
      code: string;
      statusCode: number | undefined;
    },
  ) {
    super(init.message, init.message, init.statusCode);
  }
}

export class LocalFailure extends Failure {
  constructor(message?: string) {
    super(message ?? 'COMMON.SOMETHING_WENT_WRONG', 'LOCAL_FAILURE');
  }
}
export class UnknownFailure extends Failure {
  constructor() {
    super('Unknown error', 'UNKNOWN_ERROR');
  }
}
